var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.DatePick, {
    staticClass: "Dpick",
    class: { invalid: !_setup.isValid },
    attrs: {
      format: _setup.format,
      nextMonthCaption: _setup.nextMonthCaption,
      prevMonthCaption: _setup.prevMonthCaption,
      setTimeCaption: _setup.setTimeCaption,
      weekdays: _setup.weekdays,
      months: _setup.months,
      selectableYearRange: 99,
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ toggle, inputValue }) {
          return [
            _c("button", {
              staticClass: "Dpick__inp",
              domProps: { textContent: _vm._s(_setup.otdo(inputValue)) },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return toggle.apply(null, arguments)
                },
              },
            }),
          ]
        },
      },
    ]),
    model: {
      value: _setup.date,
      callback: function ($$v) {
        _setup.date = $$v
      },
      expression: "date",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }